<div class="no-portfolio">
  
    <div class="notfound-404">
          <h1>{{displayMsg}}</h1>
    </div>
    <!-- <a (click)="home()">Go TO Homepage</a> -->
</div>
